import { OpeningCard } from '../OpeningCard/OpeningCard';
import React from 'react';
import { AdditionallyCard } from '../AdditionallyCard/AdditionallyCard';

export const useMeasurementsBlock = () => {
    const cardTypeMapping = {
        opening: ({ cardId }) => <OpeningCard cardId={cardId} />,
        additionally: ({ cardId }) => <AdditionallyCard cardId={cardId} />,
    };

    return { cardTypeMapping };
};
